<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="仓库简称" class='tiny'>
						<el-input style="width:300px;" v-model="searchInfo.position" placeholder="请输入仓库简称">
						</el-input>
					</el-form-item>
					<el-form-item label="仓库名称" class='tiny'>
						<el-input style="width:300px;" v-model="searchInfo.warehouseName" placeholder="请输入仓库名称">
						</el-input>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column prop="warehouseName" label="仓库" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="position" label="仓库简称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="warehouseVolume" label="面积(㎡)" align="center" width="130px" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="warehouseType" label="类型" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.warehouseType==1">平面仓</span>
					<span v-if="scope.row.warehouseType==2">货架仓</span>
					<span v-if="scope.row.warehouseType==3">高架仓</span>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==0" style="color:#F56C6C;font-weight: bold;">停用</span>
					<span v-if="scope.row.status==1" style="color:#67C23A;font-weight: bold;">正常</span>
				</template>
			</el-table-column>
			<el-table-column prop="memo" label="备注" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="address" label="详细地址" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{ scope.row.address}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="businessHours" label="经营时间"  align="center" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="createBy" label="创建人"  align="center" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateBy" label="修改人"  align="center" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="updateTime" label="修改时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center" :show-overflow-tooltip="true" width="100px">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<!-- <el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button> -->
					<el-button size="small" type="text" style="color:red;" @click="toBlockUp(scope.row.id)"  
					v-if="scope.row.status==1">停用</el-button> 

					<el-button size="small" type="text" style="color:#67C23A;" @click="toStartUsing(scope.row.id)"
					 v-if="scope.row.status==0">启用</el-button> 
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<!-- <div> -->
			<!-- :modal-append-to-body="false" -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="poupTitle+'仓库'" @close="addDialogClose"
			:close-on-click-modal="false" width="800px"  >
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="仓库名称" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.warehouseName"
							auto-complete="off" placeholder="请输入仓库名称" />
					</el-form-item>
					<!-- <el-form-item label-width="120px"  label="客户位置">
						<el-select filterable v-model="positionID" style="width: 300px" placeholder="请选择" clear 
						@change="fromAddress">
							<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.addressName"></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="仓库简称" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.position"
							auto-complete="off" placeholder="请输入仓库简称" />
					</el-form-item>
					<el-form-item label="仓库面积" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.warehouseVolume"
							auto-complete="off" placeholder="仓库面积" >
                            <template slot="append">㎡</template>
						</el-input>
					</el-form-item>
					<el-form-item label-width="120px"  label="仓库类型" >
						<el-select filterable v-model="storeGoodsInfo.warehouseType" style="width: 300px" placeholder="请选择" clear 
						>
							<el-option key="0" :value="1" label="平面仓"></el-option>
							<el-option key="1" :value="2" label="货架仓"></el-option>
							<el-option key="2" :value="3" label="高架仓"></el-option>
						</el-select>
					</el-form-item>
					
					<div style="display: flex;align-items: center;justify-content: space-between;width: 650px;">
						<el-form-item label="所属区域:" label-width="120px">
							<el-select clearable filterable v-model="storeGoodsInfo.provinceId" placeholder="请选择省"
								@change="provinceFocus">
								<el-option v-for="item in provinceList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="storeGoodsInfo.cityId" placeholder="请选择市"
								@change="cityFcus">
								<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="storeGoodsInfo.areaId" placeholder="请选择区"
								@change="districtFcus">
								<el-option v-for="item in districtList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
					<el-form-item label="详细地址" label-width="120px" style="width: 700px;">
						<el-input  type="text" clearable  style="width:600px;" v-model="address" placeholder="请输入详细地址" />
						<el-button icon="el-icon-position" @click="openMap()" type="primary"></el-button>
					</el-form-item>
					<el-form-item  label="经营时间"  label-width="120px">
						<el-time-picker
							is-range
							v-model="storeGoodsInfo.businessHours"
							value-format="HH:mm"
							format="HH:mm"
							range-separator="至"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							placeholder="选择时间范围"
							style="width: 300px;">
						</el-time-picker>
					</el-form-item>
					<el-form-item label="状态" class="redItem" label-width="120px">
						<el-switch v-model="storeGoodsInfo.status"  :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-form-item label="备注" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.memo"
							auto-complete="off" placeholder="请输入备注" />
					</el-form-item>
					<div style="height:50px"></div>
					<el-button type="primary" @click="submit" v-if="poupTitle=='新增'" :loading="addLoading">提交</el-button>
					<el-button type="primary" @click="submitClick" v-if="poupTitle=='编辑'" :loading="editLoading">提交</el-button>
				</el-form>
			</div>
		</el-dialog>
		<!-- </div> -->
		

		<MapSelect ref="ms" @on-select="selectAddress" />
	</div>
</template>

<script>
	import MapSelect from '@/components/MapSelect'
	export default {
		components: {	
			MapSelect
		},
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				searchInfo: {},
				sliderlist:{},
				storeGoodsInfo: {
					showStatus:true
				},
				dialogVisibleSwiper: false,

				poupTitle: '',
				locationList: [],
				provinceList: {},
				cityList: {},
				districtList: {},
				address: '',
				mainForm:{},
				latitude:'',
				longitude:'',
				positionID: '',

				addLoading: false,
				editLoading: false,
			}
		},
		methods: {
			changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			// 打开地图弹窗
			openMap() {
				
				this.$refs.ms.show();
				// 根据省市区设置初始值
				this.$refs.ms.setLocationByAddress(this.mainForm.address);
				// 根据经纬度设置初始值
				if(this.storeGoodsInfo.lat){
					this.$refs.ms.setLocationByLatLng(this.storeGoodsInfo.latitude,this.storeGoodsInfo.longitude);
				}else{
					// console.log(this.mainForm.lat,this.mainForm.lng);
				this.$refs.ms.setLocationByLatLng(this.mainForm.lat, this.mainForm.lng);
				}
				
			},
			// 地址选择后的回调函数
			selectAddress(address, lat, lng) {
				// console.log(address);
				this.address = address;
				this.latitude=lat
				this.longitude=lng	
			},
			customerLocation(){
				this.$api.routetAddress().then((res) => { 
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
                        // console.log('地址---', res.data)
                        this.locationList = res.data
					}else{

                    }
				})

				this.$api.findAreas(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
					}
				})
			},
			fromAddress(e){
				let obj = {};
				obj = this.locationList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.position = obj.addressName
			},
			//查询市
			provinceFocus(e) {
				// console.log(e);
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.province = obj.name
				// console.log('2343--', )
				this.storeGoodsInfo.provinceId = obj.id
				this.storeGoodsInfo.cityId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.findAreas(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
						// console.log(res.data);
					})
				}
			},
			//查询区
			cityFcus(e) {
				// console.log(e);
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.city = obj.name
				this.storeGoodsInfo.cityId = obj.id
				this.districtList = {}
				if (e) {
					this.$api.findAreas(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},
			districtFcus(e) {
				// console.log(e);
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.area = obj.name
				this.storeGoodsInfo.areaId = obj.id
			},
			search() { //查询
				this.page.pageNum = 1;
				this.findPmsUnit()

			},
			empty() { //清空
				this.searchInfo = {}

			},
			addDialogClose() {
				this.storeGoodsInfo = {}
			},
			findPmsUnit() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					warehouseName: this.searchInfo.warehouseName,
					position: this.searchInfo.position
				}
				this.$api.getWarehouseList(data).then((res) => {
					// console.log('开始看书看--',res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
			addCarousel() {
				this.storeGoodsInfo = {};
				this.poupTitle = '新增'
				this.dialogVisibleSwiper = true
			},

			// 提交
			submit() {
				// this.storeGoodsInfo
				this.addLoading = true;
				let data = {
					warehouseName: this.storeGoodsInfo.warehouseName,
					position: this.storeGoodsInfo.position,
					warehouseType: this.storeGoodsInfo.warehouseType,
					status: this.storeGoodsInfo.status ? 1 : 0,
					memo: this.storeGoodsInfo.memo,
					province: this.storeGoodsInfo.province,
					city: this.storeGoodsInfo.city,
					area: this.storeGoodsInfo.area,
					provinceId: this.storeGoodsInfo.provinceId,
					cityId: this.storeGoodsInfo.cityId,
					areaId: this.storeGoodsInfo.areaId,
					address: this.address,
					longitude: this.longitude,
					latitude: this.latitude,
					businessHours: this.storeGoodsInfo.businessHours ? this.storeGoodsInfo.businessHours.join("-") : '', //营业时间
					warehouseVolume: this.storeGoodsInfo.warehouseVolume
				}
				// console.log('新增--',data)
				this.$api.addWarehouseInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findPmsUnit()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
					this.addLoading = false
				})

			},

			// 编辑
			editialogVisible(e) {
				// console.log(e)
				this.storeGoodsInfo = {};
				this.poupTitle = '编辑'
				this.$api.getWarehouseInfoByID(e).then((res) => {
					if (res.state == 'success') {
						// console.log('2334--', res.data)

						this.storeGoodsInfo = res.data
						// this.storeGoodsInfo.showStatus = res.data.list[0].showStatus

						if(res.data.businessHours){
                            this.storeGoodsInfo.businessHours = res.data.businessHours.split('-');
						}
						this.storeGoodsInfo.status = res.data.status == 1 ? true : false;
						this.address = res.data.address;
						this.longitude = res.data.longitude;
						this.latitude = res.data.latitude;
						// let obj = {};
						// obj = this.locationList.find((item) => { //这里的userList就是上面遍历的数据源
						// 	return item.addressName === res.data.position; //筛选出匹配数据
						// });
						// this.positionID = obj.id
						
						// this.provinceFocus(res.data.provinceId)
						// this.cityFcus(res.data.cityId)
						this.$api.findAreas(res.data.provinceId).then((res) => {
							if (res.state == 'success') {
								this.cityList = res.data
							}
							// console.log(res.data);
						})
						this.$api.findAreas(res.data.cityId).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})

						this.dialogVisibleSwiper = true
					}
				})

			},
			// 编辑修改提交
			submitClick() {
				this.editLoading = true;
				// let data = this.storeGoodsInfo
				let data = {
					warehouseName: this.storeGoodsInfo.warehouseName,
					position: this.storeGoodsInfo.position,
					warehouseType: this.storeGoodsInfo.warehouseType,
					status: this.storeGoodsInfo.status ? 1 : 0,
					memo: this.storeGoodsInfo.memo,
					province: this.storeGoodsInfo.province,
					city: this.storeGoodsInfo.city,
					area: this.storeGoodsInfo.area,
					provinceId: this.storeGoodsInfo.provinceId,
					cityId: this.storeGoodsInfo.cityId,
					areaId: this.storeGoodsInfo.areaId,
					address: this.address,
					longitude: this.longitude,
					latitude: this.latitude,
					businessHours: this.storeGoodsInfo.businessHours ? this.storeGoodsInfo.businessHours.join("-") : '', //营业时间
					warehouseVolume: this.storeGoodsInfo.warehouseVolume,
					id: this.storeGoodsInfo.id
				}
				this.$api.updateWarehouseInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.findPmsUnit();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
					this.editLoading = false;
				})

			},
			// 停用
			toBlockUp(e) {
				// console.log(e)
				var str = "此操作将停用该仓库, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.warehouseDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 启用
			toStartUsing(e) {
				// console.log(e)
				var str = "此操作将启用该仓库, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.warehouseDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
			},
		},




		created() {
			this.findPmsUnit()
			this.customerLocation()
		}
	}
</script>

<style lang="less" scoped>

	.el-form-item__content{
		margin: 0 !important;
	}

	// /deep/.el-dialog__wrapper{
	// 	position: absolute !important;
	// }
	// /deep/.v-modal{
	// 	position: absolute !important;
	// }
</style>
